<template>
  <div>
    <NavAdminTop />
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
